/**
 * /logistica/cadastros — CRUD de Motoristas + Veiculos + Equipes.
 *
 * Layout: 3 cards lado a lado (resumido) ou tabs. Aqui escolhemos 3
 * sub-paginas em 1 router via tabs no proprio shell.
 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

import EntityHeader from "../../../components/EntityHeader";
import { useAuth } from "../../../context/AuthContext";
import { PageContainer, PageState } from "../../../styles/shared";

import { Card, SectionTitle } from "../../Orcamentos/styles";

import MotoristasTab from "./MotoristasTab";
import VeiculosTab from "./VeiculosTab";
import EquipesTab from "./EquipesTab";


// Cada aba lê um endpoint com permissão própria: sem ela a aba carregaria
// vazia (ou com erro) em vez de sumir.
const TABS = [
  { id: "motoristas", label: "Motoristas", requer: "motorista:view" },
  { id: "veiculos", label: "Veículos", requer: "veiculo:view" },
  { id: "equipes", label: "Equipes de instalação", requer: "equipe:view" },
];


export default function Cadastros() {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const abasVisiveis = TABS.filter((t) => hasPermission(t.requer));
  const [tabEscolhida, setTab] = useState(null);
  const tab = abasVisiveis.some((t) => t.id === tabEscolhida)
    ? tabEscolhida
    : abasVisiveis[0]?.id;

  return (
    <PageContainer>
      <EntityHeader
        title="Cadastros de logística"
        subtitle="Motoristas, veículos e equipes (ADR-0026)"
        actions={[{
          label: "Voltar",
          icon: <FiArrowLeft size={14} />,
          onClick: () => navigate("/logistica/cargas"),
        }]}
      />

      {abasVisiveis.length === 0 && (
        <PageState>Você não tem acesso a nenhum cadastro de logística.</PageState>
      )}

      {abasVisiveis.length > 0 && (
      <Card>
        <SectionTitle>Selecione um cadastro</SectionTitle>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {abasVisiveis.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setTab(t.id)}
              style={{
                padding: "8px 16px",
                background: tab === t.id ? "var(--accent-soft)" : "var(--surface)",
                color: tab === t.id ? "var(--accent)" : "inherit",
                border: `1px solid ${tab === t.id ? "var(--accent)" : "var(--border)"}`,
                borderRadius: 6,
                fontWeight: 600,
                cursor: "pointer",
                fontSize: 14,
              }}
            >
              {t.label}
            </button>
          ))}
        </div>
      </Card>
      )}

      {tab === "motoristas" && <MotoristasTab />}
      {tab === "veiculos" && <VeiculosTab />}
      {tab === "equipes" && <EquipesTab />}
    </PageContainer>
  );
}
